/**
 * 移动端图片预览（点击打开 + 双指缩放 + 单指平移 + 仅×关闭）
 * 在页面加载后调用 initImgPreview() 即可
 */
export function initImgPreview() {
    const isMobile = /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent)
    if (!isMobile) return

    let startX = 0, startY = 0, touchTime = 0

    // 监听图片点击（通过 touchend 模拟 tap）
    document.body.addEventListener('touchend', function (e) {
        const target = e.target
        if (target.tagName !== 'IMG') return

        // 过滤小图标（宽度 ≤ 50px）
        const w = target.naturalWidth || target.width || 0
        if (w <= 50) return

        // 判断是否为有效点击（防止滚动/长按误触）
        const dx = Math.abs(e.changedTouches[0].clientX - startX)
        const dy = Math.abs(e.changedTouches[0].clientY - startY)
        const dur = Date.now() - touchTime
        if (dur > 300 || dx > 15 || dy > 15) return

        openPreview(target.src)
    }, { passive: true })

    document.body.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX
        startY = e.touches[0].clientY
        touchTime = Date.now()
    }, { passive: true })

    // 打开预览遮罩
    function openPreview(url) {
        // 移除已存在的遮罩
        const old = document.querySelector('.img-preview-mask')
        if (old) old.remove()

        const mask = document.createElement('div')
        mask.className = 'img-preview-mask'
        // background: rgba(0,0,0,0.95);
        mask.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(255,255,255,0.95); 
            z-index: 999999;
            display: flex;
            align-items: center;
            justify-content: center;
            touch-action: none; /* 禁止浏览器手势，完全由 JS 控制 */
        `

        const img = document.createElement('img')
        img.src = url
        img.style.cssText = `
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            user-select: none;
            will-change: transform;
            transform-origin: center center;
        `

        const close = document.createElement('div')
        close.innerText = '✕'
        // color: #fff;
        // background: rgba(255,255,255,0.2);
        close.style.cssText = `
            position: fixed;
            top: 26px;
            right: 26px;
            width: 46px;
            height: 46px;
            line-height: 46px;
            text-align: center;
            font-size: 28px;
            color: #000; 
            background: rgba(0,0,0,0.1); 
            border-radius: 50%;
            z-index: 1000000;
            touch-action: none; /* 防止浏览器干扰 */
        `

        mask.appendChild(img)
        mask.appendChild(close)
        document.body.appendChild(mask)

        // 关闭按钮：阻止事件冒泡和默认行为，避免触发页面上其他元素
        close.addEventListener('touchend', (e) => {
            e.stopPropagation()
            e.preventDefault()
            mask.remove()
        }, { passive: false })

        // 初始化手势（缩放+平移）
        initImageGestures(img)
    }

    // 图片手势处理（缩放+平移）
    function initImageGestures(img) {
        let scale = 1
        let translateX = 0
        let translateY = 0

        let initialDistance = 0          // 双指初始距离
        let initialScale = 1             // 双指开始时的缩放值
        let initialTranslateX = 0, initialTranslateY = 0  // 双指/单指开始时的位移

        let touchStartX = 0, touchStartY = 0   // 单指开始位置
        let isPanning = false
        let isPinching = false

        // 更新 transform
        function updateTransform() {
            img.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`
        }

        // 触摸开始
        img.addEventListener('touchstart', (e) => {
            e.preventDefault() // 阻止一切默认行为（滚动/缩放）
            const touches = e.touches
            if (touches.length === 2) {
                // 双指：进入缩放模式
                isPinching = true
                isPanning = false
                const dx = touches[0].clientX - touches[1].clientX
                const dy = touches[0].clientY - touches[1].clientY
                initialDistance = Math.hypot(dx, dy)
                initialScale = scale
                initialTranslateX = translateX
                initialTranslateY = translateY
            } else if (touches.length === 1) {
                // 单指：进入平移模式
                isPanning = true
                isPinching = false
                touchStartX = touches[0].clientX
                touchStartY = touches[0].clientY
                initialTranslateX = translateX
                initialTranslateY = translateY
            }
        }, { passive: false })

        // 触摸移动
        img.addEventListener('touchmove', (e) => {
            e.preventDefault()
            const touches = e.touches

            if (touches.length === 2 && isPinching) {
                // 双指缩放
                const dx = touches[0].clientX - touches[1].clientX
                const dy = touches[0].clientY - touches[1].clientY
                const currentDistance = Math.hypot(dx, dy)
                let newScale = initialScale * (currentDistance / initialDistance)
                newScale = Math.max(0.5, Math.min(3, newScale)) // 限制缩放范围
                scale = newScale
                updateTransform()
            } else if (touches.length === 1 && isPanning) {
                // 单指平移
                const dx = touches[0].clientX - touchStartX
                const dy = touches[0].clientY - touchStartY
                translateX = initialTranslateX + dx
                translateY = initialTranslateY + dy
                updateTransform()
            }
        }, { passive: false })

        // 触摸结束
        img.addEventListener('touchend', (e) => {
            if (e.touches.length === 0) {
                // 所有手指抬起，结束所有手势
                isPanning = false
                isPinching = false
            } else if (e.touches.length === 1) {
                // 双指变单指：结束缩放，进入平移模式
                isPinching = false
                isPanning = true
                // 重新记录平移起点，避免突变
                touchStartX = e.touches[0].clientX
                touchStartY = e.touches[0].clientY
                initialTranslateX = translateX
                initialTranslateY = translateY
            }
        }, { passive: false })

        // 触摸取消（如被手势打断）
        img.addEventListener('touchcancel', (e) => {
            isPanning = false
            isPinching = false
        }, { passive: false })
    }
}